import { Exception } from '@core/exceptions/exception';

export class SignInProcessException extends Exception {
  constructor(message: string = 'Sign in process exception.') {
    super(message);
  }
}
